import React from "react";
import "../css/main.css";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";
import DownloadInfo from "@/components/DownloadInfo";
import { Constants } from "../const/result";
import {
  guageChange,
  gaugeOptions,
  splineOptions,
} from "../utils/chartOptions";
import { reportResult } from "../utils/tools";
import moment from "moment";
import { connect } from "react-redux";
import { actions } from "@/store/actions/result";
import { Toast } from "antd-mobile";
import worker from "workerize-loader!../utils/worker.js"; // eslint-disable-line import/no-webpack-loader-syntax
import { throttle, browser } from "../utils/utils";
// import TestManager from "../utils/worker";

const STATUS_TEXT_MAP = {
  ping: {
    main: "PING",
    sub: "星域百万节点正在测试延时",
  },
  upload: {
    main: "上传",
    sub: "星域百万节点正在测试上传",
  },
  download: {
    main: "下载",
    sub: "星域百万节点正在测试下载",
  },
  default: {
    main: "",
    sub: "",
  },
};
class Console extends React.Component {
  constructor(props) {
    super(props);

    this.downloadPoints = [];
    this.uploadPoints = [];

    this.worker = worker();
    // this.worker = new TestManager(this);

    this.worker.onmessage = (e) => {
      // console.log("message:", e.data);
      const { data } = e;
      switch (data.type) {
        case "nodes":
          this.onNodes(data.data);
          break;
        case "ping":
          this.onPing(data.data);
          break;
        case "prepare":
          this.onPrepare(data.data);
          break;
        case "download":
          this.onDownload(data.data);
          break;
        case "upload":
          this.onUpload(data.data);
          break;
        case "realtime":
          this.onRealtime(data.data);
          break;
        default:
          console.log("unknown message", data);
      }
    };

    this.record = JSON.parse(localStorage.getItem("testRecord")) || [];

    highchartsMore(Highcharts);
    solidGauge(Highcharts);

    this.state = {
      color: {
        downloadTitle: "",
        uploadTitle: "",
      },
      netType: "wifi",
      ping: 0,
      isp: "获取中...",
      ip: "",
      location: "",
      isTesting: false,
      progressAnimation: 0,
      downloadSpeed: 0,
      uploadSpeed: 0,
      gaugeOptions: gaugeOptions(),
      splineOptions: splineOptions({ backgroundColor: "#151414" }),
      speedIndicator: "default",
    };
    // this.getDownloadInfo();
  }

  // getDownloadInfo = () => {
  //   if (browser("ios")) return false;
  //   const callback = (res) => {
  //     console.log("请求结果：", res);
  //     if (!res.downloadUrl) {
  //       Toast.info("获取下载二维码失败");
  //       return false;
  //     }
  //     window.localStorage.setItem("downloadUrl", res.downloadUrl);
  //   };
  //   this.props.queryDownloadInfo({
  //     payload: { origin: "1", flavor: 1 },
  //     callback,
  //   });
  // };

  // postMessage = (data) => {
  //   // console.log("message:", e.data);
  //   switch (data.type) {
  //     case "nodes":
  //       this.onNodes(data.data);
  //       break;
  //     case "ping":
  //       this.onPing(data.data);
  //       break;
  //     case "prepare":
  //       this.onPrepare(data.data);
  //       break;
  //     case "download":
  //       this.onDownload(data.data);
  //       break;
  //     case "upload":
  //       this.onUpload(data.data);
  //       break;
  //     case "realtime":
  //       this.onRealtime(data.data);
  //       break;
  //     default:
  //       console.log("unknown message", data);
  //   }
  // };

  onNodes = (data) => {
    this.setState({
      isp: data.isp,
      ip: data.ip,
      location: data.location,
    });
    const mode = sessionStorage.getItem("testMode");
    if (Number(mode) === 1) {
      sessionStorage.removeItem("testMode");
      this.handleTest();
    }
  };

  onPing = (data) => {
    if (data < 1) return;
    const ping = this.state.ping;
    if (ping === 0 || ping > data) {
      console.log("recv ping:", data);
      this.setState({
        ping: data,
        speedIndicator: "ping",
      });
    }
  };

  onPrepare = (data) => {
    this.downloadPoints = [];
    this.uploadPoints = [];
    this.setState({
      isTesting: true,
      progressAnimation: 1,
      speedIndicator: "download",
      ping: 0,
      downloadSpeed: 0,
      uploadSpeed: 0,
      color: {
        downloadTitle: Constants.DOWNLOAD_COLOR,
        uploadTitle: "",
      },
      gaugeOptions: guageChange("download"),
    });
  };

  onDownload = (data) => {
    this.setState({
      downloadSpeed: data,
      isTesting: true,
      progressAnimation: 2,
      speedIndicator: "upload",
      color: {
        downloadTitle: "",
        uploadTitle: Constants.UPLOAD_COLOR,
      },
      gaugeOptions: guageChange("upload"),
    });
  };

  onUpload = (data) => {
    this.setState({
      uploadSpeed: data,
      isTesting: false,
      progressAnimation: 0,
      speedIndicator: "default",
      color: {
        downloadColor: "",
        uploadColor: "",
      },
      gaugeOptions: guageChange(),
    });

    const { ip, netType, isp, location, ping, downloadSpeed, uploadSpeed } =
      this.state;
    const result = {
      stime: moment().format("YYYY-MM-DD HH:mm:ss"),
      ts: Math.floor(Date.now() / 1000),
      ip,
      netType,
      isp,
      location,
      ping,
      downloadSpeed,
      uploadSpeed,
      downloadPoints: this.downloadPoints,
      uploadPoints: this.uploadPoints,
    };
    this.record.push(result);
    localStorage.setItem("testRecord", JSON.stringify(this.record));
    sessionStorage.setItem("testResult", JSON.stringify(result));
    reportResult(result);
    this.props.history.push("/result");
  };

  onRealtime = (data) => {
    if (data.type === "download") {
      this.downloadPoints.push(data.speed);
    } else {
      this.uploadPoints.push(data.speed);
    }
    const maxSpeed = this.getMaxSpeed(data.speed);

    this.setState({
      speedIndicator: data.type,
      gaugeOptions: {
        yAxis: {
          max: maxSpeed,
        },
        series: [
          {
            data: [data.speed],
            // data: [...this.downloadPoints],
          },
        ],
      },
      splineOptions: {
        // yAxis: {
        //   softMax: Math.ceil(maxSpeed),
        // },
        series: [
          {
            color: Constants.DOWNLOAD_COLOR,
            data: this.downloadPoints,
          },
          {
            color: Constants.UPLOAD_COLOR,
            data: this.uploadPoints,
          },
        ],
      },
    });
  };

  getMaxSpeed = (speed) => {
    let maxSpeed = Constants.MAX_SPEED;
    if (speed < Constants.MAX_SPEED) {
      maxSpeed = Constants.MAX_SPEED;
    } else if (speed >= Constants.MAX_SPEED && speed < 400) {
      maxSpeed = 400;
    } else if (speed >= 400) {
      maxSpeed = 600;
    }
    return maxSpeed;
  };

  setNetType = () => {
    const type = navigator.connection.type;
    // const type = "cellular";
    console.log("netType:", type);
    if (this.state.netType !== type) {
      const netType =
        type !== "wifi" ? (type === "ethernet" ? type : "cellular") : type;
      this.setState({ netType });
    }
    this.worker.postMessage({
      type: "getNodes",
    });
  };

  checkNetType = () => {
    if (
      navigator.connection !== undefined &&
      navigator.connection.type !== undefined
    ) {
      this.setNetType();
      navigator.connection.onchange = () => this.setNetType();
    } else {
      this.worker.postMessage({
        type: "getNodes",
      });
    }
  };

  componentDidMount() {
    this.checkNetType();
    //   window.addEventListener('online',  function(){
    //     console.log("onLine");
    //   });
    //   window.addEventListener('offline', function(){
    //     console.log("offLine");
    //   });

    console.log(this.props);
  }

  startTest = () => {
    const { search } = this.props.location;
    const query = new URLSearchParams(search);
    const data = {
      uploadConnections: query.get("uc") || Constants.UPLOAD_CONNECTIONS,
      downloadConnections: query.get("dc") || Constants.DOWNLOAD_CONNECTIONS,
    };
    this.setState({
      speedIndicator: "ping",
    });
    this.worker.postMessage({
      type: "startTest",
      data,
    });
  };

  stopTest = () => {
    this.worker.postMessage({
      type: "stopTest",
    });
    this.setState({
      isTesting: false,
      ping: 0,
      downloadSpeed: 0,
      uploadSpeed: 0,
      progressAnimation: 0,
      speedIndicator: "default",
      color: {
        downloadColor: "",
        uploadColor: "",
      },
      gaugeOptions: gaugeOptions(),
      splineOptions: splineOptions({ backgroundColor: "#151414" }),
    });
  };

  handleTest = () => {
    console.log("this.state.isTesting: ", this.state.isTesting);
    if (this.state.isTesting) {
      this.stopTest();
    } else {
      this.startTest();
    }
  };

  nodeSelected = (event) => {
    this.worker.postMessage({
      type: "getNodes",
    });
  };

  render() {
    const {
      netType,
      progressAnimation,
      ping,
      downloadSpeed,
      color,
      uploadSpeed,
      gaugeOptions,
      splineOptions,
      isTesting,
      isp,
      speedIndicator,
    } = this.state;
    let progressAnimationClassName = "";
    if (progressAnimation === 1) {
      progressAnimationClassName = "progress-right";
    } else if (progressAnimation === 2) {
      progressAnimationClassName = "progress-left";
    }
    const netTypeImg =
      netType === "wifi"
        ? require("../images/wifi.png")
        : netType === "ethernet"
        ? require("../images/ethernet.png")
        : require("../images/signal.png");
    const isIOS = browser("ios") || browser("iPhone");
    return (
      <div className="main">
        <div className="container flex-container">
          <div className="nav-bar">
            <span className="nav-left"></span>
            <span className="nav-title">
              <span>星域测速</span>
              {/* <img
                className="title-icon"
                src={require("../images/5G.png")}
                alt="5G"
              ></img> */}
            </span>
            <span className="nav-right"></span>
          </div>
          <select
            onChange={this.nodeSelected}
            style={{
              width: "50vw",
              height: "30px",
              fontSize: "18px",
              display: "none",
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <div className="info-row">
            <ul>
              <li>
                <div className="sub-title">延时/ms</div>
                <div className="sub-value">{Math.floor(ping / 2) || "--"}</div>
              </li>
              <li>
                <div
                  className="sub-title"
                  style={{ color: color.downloadTitle }}
                >
                  下载/Mbps
                </div>
                <div className="sub-value">{downloadSpeed || "--"}</div>
              </li>
              <li>
                <div className="sub-title" style={{ color: color.uploadTitle }}>
                  上传/Mbps
                </div>
                <div className="sub-value">{uploadSpeed || "--"}</div>
              </li>
            </ul>
          </div>
          <div className="flex-row">
            <HighchartsReact highcharts={Highcharts} options={gaugeOptions} />
            <div className="speed-status">
              {STATUS_TEXT_MAP[speedIndicator]["main"]}
            </div>
          </div>
          <div>{STATUS_TEXT_MAP[speedIndicator]["sub"]}</div>
          <div className="flex-row">
            <HighchartsReact highcharts={Highcharts} options={splineOptions} />
          </div>
          <div className="node-row flex-row">
            <ul>
              <li>
                <img src={netTypeImg} alt="isp"></img>
                <div>{isp}</div>
              </li>
              <li className={`line ${progressAnimationClassName}`}>
                <div className="progress-item"></div>
              </li>
              <li>
                <img src={require("../images/nodes.png")} alt="nodes"></img>
                <div>星域节点</div>
              </li>
            </ul>
          </div>
          <div className="button-row flex-row">
            <button
              className={`main-btn ${
                isTesting ? "main-btn-stop" : "main-btn-start"
              }`}
              onClick={throttle(this.handleTest, 1500)}
            >
              {isTesting ? "停止测速" : "开始测速"}
            </button>
          </div>
          {/* {!isIOS && (
            <DownloadInfo url={this.props.data?.downloadInfo?.downloadUrl} />
          )} */}
        </div>
        <div
          className="tab-bar"
          style={{ visibility: isTesting ? "hidden" : "visible" }}
        >
          <ul>
            <li>
              <img src={require("../images/test_a.png")} alt="test"></img>
            </li>
            <li>
              <img
                src={require("../images/record_b.png")}
                alt="record"
                onClick={() => {
                  window.location.href = "/record";
                  // this.props.history.push("/record")
                }}
              ></img>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ result }) => {
  return {
    data: result,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // queryDownloadInfo: (data) => dispatch(actions.getDownloadInfo(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Console);
